import React from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { NavSidebarItems } from './';

let NavSidebar = ({ location, translate, rest, match, currentLanguage, dispatch }) => {
  return (
    <div className="col-lg-3">
      <div className="hidden-md-down">
        <div id="sidebar">
          <h2 className="hidden-md-down">{translate('my-annatel')}</h2>
          {NavSidebarItems(location, translate, match, currentLanguage, dispatch)}
        </div>
      </div>
    </div>
  )}
const mapStateToProps = (state, { location, rest }) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    message: state.Flash.message,
    location,
    rest,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

  NavSidebar = connect(
    mapStateToProps,
    mapDispatchToProps
  )(NavSidebar);
export default NavSidebar;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavSidebar.js